import { VehicleInspectionFilters } from './VehicleInspectionFilters';

export function VehicleInspectionsRouteActions() {
  return (
    <div>
      <VehicleInspectionFilters />
    </div>
  );
}
